import React from "react"
import types from "prop-types"
import { dynamicRangeSubmissionsExample, monthRangeSubmissionInclusionDescription } from "utils/scheduledReportExportHelpers"

const MonthsSubmissionDescription = ({ dateFilterType, startDate, submissionPreviousRangeLength = null }) => {
  const monthCount = submissionPreviousRangeLength || 1

  const beginningDate = startDate.subtract(monthCount, "M").startOf("month")
  const endingDate = startDate.subtract(1, "M").endOf("month")

  return (
    <div className="text-xs text-dark mt-2">
      <p className="mb-4">
        {monthRangeSubmissionInclusionDescription(dateFilterType)}
      </p>
      <p>
        {dynamicRangeSubmissionsExample({
          startDate, beginningDate, endingDate, dateFilterType,
        })}
      </p>
    </div>
  )
}

MonthsSubmissionDescription.propTypes = {
  dateFilterType: types.string.isRequired,
  startDate: types.object.isRequired,
  submissionPreviousRangeLength: types.number,
}

export default MonthsSubmissionDescription
